<template>
    
    <div>
        <el-button type="primary" @click="addAdmin" class="addAdmin">添加管理员</el-button>
        <div class="down">
            <el-table
                :data="adminList"
                ref="adminList"
                style="width: 100%;">
                   <el-table-column
                type="index"
                 label="序号"
                min-width="50">
                </el-table-column>
                <el-table-column
                prop="adminId"
                label="ID"
                sortable
                min-width="80">
                </el-table-column>
                    <el-table-column
                prop="adminTrueName"
                label="真实名字"
                sortable
                min-width="100">
                </el-table-column>
                <el-table-column
                prop="adminUserName"
                label="用户名"
                sortable
                min-width="180">
                </el-table-column>
                 <el-table-column
                prop="ident"
                label="描述" 
                sortable
                min-width="100">
                </el-table-column>
                <el-table-column
                prop="remark"
                label="备注" 
                min-width="600">
                </el-table-column>
                  <el-table-column
                prop="isValide"
                label="状态" 
                min-width="100">
                <template slot-scope="scope">
                    <div> {{ scope.row.isValide == 1?"有效":"无效" }}</div>
                </template>
                </el-table-column>
                <el-table-column
                prop="faceUrl"
                label="头像"
                min-width="180">
                <template slot-scope="scope">
                 
                      <img :src="scope.row.faceUrl" style="width: 30px;height: 30px;border-radius: 15px" @click="clickBig(scope.row.faceUrl)" alt=""/>
                 
                </template>
                
                 </el-table-column>
                 <el-table-column
                prop="addTime"
                label="日期"
                sortable
                min-width="280">
                 <template slot-scope="scope">
                    <div> {{timestampToTime(scope.row.addTime)}}</div>
                </template>
                </el-table-column>

                 <el-table-column
                prop="adminId"
                label="操作"
                min-width="280">
                 <template slot-scope="scope">
                    <div>
                        <el-button type="primary" @click="editAdminInfo(scope.row)">编辑</el-button>
                        <el-button type="primary" @click="adminDetail(scope.row)">详情</el-button>
                    </div>
                </template>
                </el-table-column>

            </el-table>
           
           <!-- <ul class="infinite-list" style="overflow:auto">
                <li v-for="(obj,index) in runLog"  v-bind:key="index" class="infinite-list-item" >{{ obj.body }}</li>
            </ul>-->



<div class="block">
    
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageNum"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total,sizes, prev, pager, next,jumper"
      :total="total">
    </el-pagination>
  </div>

        </div>
        <el-dialog
            :title="title"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
            <span>
                <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="真实名字">
                    <el-input v-model="form.adminTrueName"></el-input>
                </el-form-item>
                <el-form-item label="用户名">
                    <el-input v-model="form.adminUserName"></el-input>
                </el-form-item>
                 <el-form-item label="密码" v-if='condition'>
                    <el-input v-model="form.adminPassword"></el-input>
                </el-form-item>
               
                
                <el-form-item label="禁止登录">
                    <el-radio-group v-model="form.isValide">
                    <el-radio :label="0" border>禁止</el-radio>
                    <el-radio :label="1" border>启用</el-radio>
                    </el-radio-group>
                </el-form-item>
                 <el-form-item label="描述">
                    <el-input type="text" v-model="form.ident"></el-input>
                </el-form-item>
                <el-form-item label="角色">
                     <el-select v-model="selectValue" clearable placeholder="请选择" @change="change">
                        <el-option
                        v-for="item in roles"
                        :key="item.roleId"
                        :label="item.roleRemark"
                        :value="item.roleId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="form.remark"></el-input>
                </el-form-item>
              
                </el-form>

            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addAdminFunct">确 定</el-button>
            </span>
            </el-dialog>

 <el-dialog
            title="图片预览"
            :visible.sync="centerDialogVisibleimgSrc"
            width="30%"
            center>
         <span style="text-align:center;">
              <img :src='imgSrc'  style="text-align:center;">
         </span>
            
            
            </el-dialog>

    <el-dialog
            title="详情"
            :visible.sync="centerDialogVisibleDetailSrc"
            width="30%"
            center>
         <span style="text-align:center;">
             <detail :adminId="adminId" :key="adminId"></detail>
         </span>
             
            
            </el-dialog>

    </div>

    
</template>
<script>
import {Message} from 'element-ui';
import detail from './Detail';
export default {
name:"version",
    data(){
        return {
            title:"后台运行日志",
            adminList:[],
            condition:true,
            dialogTitle:"",
            centerDialogVisible: false,
            centerDialogVisibleDetailSrc:false,
            centerDialogVisibleimgSrc:false,
            pageNum:1,
            adminId:0,
            roles:[],
            selectValue:[],
            totalPage:10,
            pageSize:10,
            total:1,
            imgSrc:'',
            form: {
                adminId:0,
                adminTrueName:'',
                adminUserName: '',
                adminPassword: '',
                isValide: 1,
                faceUrl:'',
                roleId:0,
                remark: '',
                ident: ''
            },
            params:{
                pageSize:10,
                pageNum:1
            }
        }
    },
     components:{detail},
    methods:{
       adminDetail(info){
           console.log(info)
           this.adminId = info.adminId
           this.centerDialogVisibleDetailSrc=true
          
       },
       clickBig(obj){
           this.imgSrc=obj;
           this.centerDialogVisibleimgSrc = true
       },
       editAdminInfo(info){
           this.condition=false
           this.form.adminUserName=info.adminUserName
           this.form.adminPassword=info.adminPassword
           this.form.isValide=info.isValide
           this.form.adminTrueName=info.adminTrueName
           this.form.remark=info.remark
           
           this.form.faceUrl=info.faceUrl
           this.form.ident=info.ident
           this.form.adminId=info.adminId
           this.centerDialogVisible = true

           this.params.pageSize=100000
           this.params.pageNum=1
           if(info.roles.length > 0){
               this.form.roleId=info.roles[0].roleId
               this.selectValue = info.roles[0].roleId
           }
          this.postRequest('/role/list',this.params).then(resp => {
              if(resp){
                  this.roles = resp.data.list
              }
          })
          this.params.pageSize=10
           this.params.pageNum=1
       },
       change(obj){
          
            this.form.roleId=obj
       },
       handleSizeChange(val) {
          this.params.pageSize = val;
          this.loadAdminList();
       },
       handleCurrentChange(val) {
          this.params.pageNum = val;
          this.loadAdminList();
       },
       addAdmin(){
           this.centerDialogVisible = true
           this.title = '添加管理员';

       },
       addAdminFunct(){
           this.postRequest('/admin/register', this.form).then(resp => {
                if (resp) {
                    this.centerDialogVisible = false
                    this.loadAdminList()
                    Message.success({message: resp.msg})
                }
            })
       },
       onSubmit() {
        console.log('submit!');
      },
       loadAdminList(){
             this.postRequest('/admin/list', this.params).then(resp => {
                this.loading = false;
                if (resp) {
                    this.pageNum = resp.data.pageNum
                    this.totalPage = resp.data.totalPage
                    this.pageSize=resp.data.pageSize
                    this.total = resp.data.total
                    this.adminList = resp.data.list
                }
            })
       }     
    },
 mounted(){
     this.loadAdminList();
 }
}
</script>
<style>
    .block{
        margin-top: 1%;
        margin-right: 1%;
    }
    .infinite-list{
        border: rgba(92, 48, 145, 0.04);
        margin-top: 1%;
        margin-left: 10%;
    }
    .alal{
      background-image: url(../../assets/1231232.jpg);
        
    }
    .all{
       box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }
   
    .h1{
        font-style: initial;
        font-size: 50px;
    }
    .button{
        margin-top: 1%;
        margin-left: 20%;
    }
</style>